import React, { Component } from 'react';
import {Checkbox, Dialog, Divider, FlatButton, Paper} from 'material-ui';
import _ from 'lodash';
import ProgressIndicator from "material-ui/CircularProgress";

const ProductDialogRow = ({ label, checked, onCheck }) => (
  <Paper style={{ backgroundColor: 'papayawhip', padding: 10, marginBottom: 10 }}>
    <Checkbox
      style={{ color: 'white' }}
      label={label}
      checked={checked}
      onCheck={onCheck}
      />
  </Paper>
);

class AddModifierDialog extends Component {
  state ={
    modifiers: null,
    selected: {}
  };

  handleCheckChange = (modifier, checked) => {
    let newState;
    if(checked) {
      newState = {
        ...this.state.selected,
        [modifier.id]: modifier,
      };
    } else {
      newState = _.filter(this.state.selected, (value, key) => key !== modifier.id);
    }

    this.setState({
      selected: newState,
    });
  };

  renderContent() {
    const { modifiers } = this.state;
    if(!modifiers) return <ProgressIndicator />;

    let { skipModifiers } = this.props;

    skipModifiers = skipModifiers || [];

    const candidateModifiers = modifiers
      .filter(doc => !skipModifiers.find(p => p.id === doc.id));

    if(_.isEmpty(candidateModifiers)) return <h3>No more modifiers found.</h3>;


    return candidateModifiers
      .map(doc => (
        <ProductDialogRow
          label={doc.name}
          onCheck={(e, checked) => this.handleCheckChange(doc, checked)}
          checked={this.state.selected[doc.id]}
        />
      ));

  }

  render() {
    const { onModifiersSelected } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.props.onClose}
      />,
      <FlatButton
        label="Add"
        onClick={() => onModifiersSelected(this.state.selected)}
        primary
      />,
    ];
    return (
      <Dialog
        title="Add Modifiers"
        actions={actions}
        modal
        open={this.props.open}
        {...this.props}
      >
      {this.renderContent()}
      </Dialog>
    );
  }

  async fetchModifiers() {
    const { restaurantPath } = this.props;

    const modifierSnaps = await restaurantPath.collection('modifiers').get();

    if(!modifierSnaps.docs) {
      return this.setState({
        modifiers: [],
      });
    }

    this.setState({
      modifiers: modifierSnaps.docs.map(modifier => ({ id: modifier.id, ...modifier.data() })),
    });
  }


  async componentDidMount() {
    await this.fetchModifiers();
  }


  componentWillUnmount() {
    console.log('Unmount AddProductDialog');
  }


}

export default AddModifierDialog;



// WEBPACK FOOTER //
// ./src/components/AddModifierDialog.js